export default __webpack_public_path__ + "d427fc11b94f877bd1b0481f921990d2.jpg";